import React, { Fragment, useEffect, useRef, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { Spinner, useTheme } from '@ui-kitten/components';
import { useDispatch } from 'react-redux';

import { FilterTag } from '../../../Components/Filter';
import Search from '../../../Components/Search';
import RecentSearched from './Recent';
import { pushRecentlySearch } from '../../../RTK/search';
import { filter } from '../../../RTK/defaultValues';
import themeStyle from '../../../Theme/styles';

import { TYPE_PLACEHOLDER, TYPE_STATUS } from '../constants';
import { TYPE } from '../types';

import Cuisines from './Cuisines';

type Props = {
  isLoading: boolean;
  type: TYPE;
  onSearch: (d: string, t: boolean) => void;
};

type SearchProps = {
  _onInputChange: (text: string, immediate: boolean) => void;
};

const SearchHeader = ({ isLoading, type, onSearch }: Props) => {
  const dispatch = useDispatch();
  const searchRef = useRef<SearchProps>();
  const isTagRef = useRef<boolean>();
  const theme = useTheme();
  const [searchValue, setSearchValue] = useState('');

  const _onSearch = (value: string) => {
    if (value) {
      dispatch(pushRecentlySearch({ type, value }));
    }
    setSearchValue(value);
    onSearch(value, isTagRef.current);
    isTagRef.current = false;
  };

  return (
    <View
      style={[themeStyle.pageBackground, themeStyle.pageVerticalSpacingMedium]}
    >
      <View
        style={[
          themeStyle.pageHorizontalSpacing,
          themeStyle.spacingBottomMedium,
        ]}
      >
        <Search
          // @ts-ignore: just ref issue, _onInputChange is still getting called anyway pls fix the type when have more time
          ref={searchRef}
          placeholder={TYPE_PLACEHOLDER[type]}
          inputStyle={{ borderRadius: 5 }}
          fill={theme['text-basic-color']}
          onSearch={_onSearch}
          {...(isLoading && {
            accessoryLeft: () => (
              <Spinner size="small" status={TYPE_STATUS[type]} />
            ),
          })}
          autoFocus
        />
      </View>
      {Boolean(searchValue) && type === TYPE.HOME && (
        <FilterTag isLoading={isLoading} useIn={filter.useCase.SEARCH} />
      )}
      {!Boolean(searchValue) && (
        <RecentSearched
          type={type}
          onPress={(value) => {
            searchRef.current?._onInputChange(value, true);
          }}
        />
      )}
      {!Boolean(searchValue) && type === TYPE.HOME && (
        <Cuisines
          onPress={(value: string) => {
            isTagRef.current = true;
            searchRef.current?._onInputChange(value, true);
          }}
        />
      )}
    </View>
  );
};

export default SearchHeader;
